export default [

    // riepilogo situazione per utenti abilitati alla gestione
    // visualizzazione delle news
    {
        path: '/news',
        name: 'news',
        meta: {layout: 'layout-standard', requiresAuth: true, mainMenuActive:'5', subMenuActive:'1', title: 'headers.news-title'},
        components: {
            default: () => import(/* webpackChunkName: "news" */ './views/news'),
            'section-header': () => import(/* webpackChunkName: "news" */ './components/section-header')
        }
    },

];